import { ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";

export default function CapitalProtection() {
  return (
    <section className="relative py-20 sm:py-24 border-t border-white/[0.06]" data-testid="capital-protection-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-[#D4AF37]/25 bg-gradient-to-br from-[#14141A] to-[#0B0B0F] p-8 sm:p-12 shadow-[0_8px_32px_rgba(0,0,0,0.5)]">
            <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.12),transparent_70%)]" aria-hidden="true" />

            <div className="relative flex flex-col gap-8 md:flex-row md:items-center md:gap-12">
              <div className="shrink-0">
                <div className="rounded-2xl border border-[#D4AF37]/35 bg-[#D4AF37]/[0.08] p-5 text-[#D4AF37] w-fit">
                  <ShieldCheck className="h-9 w-9" />
                </div>
              </div>

              <div>
                <div className="flex items-center gap-3">
                  <span className="h-px w-8 bg-[#D4AF37]/60" aria-hidden="true" />
                  <span className="font-mono text-xs tracking-[0.3em] text-[#D4AF37] uppercase">
                    Chapter 04 — Risk Framework
                  </span>
                </div>
                <h2 className="mt-4 font-display text-3xl sm:text-4xl font-bold tracking-tight text-white">
                  Capital Protection Plan
                </h2>
                <p className="mt-4 max-w-2xl text-base sm:text-lg leading-relaxed text-[#99A1AF]">
                  Capital Protection Plan is available with eligible investment products.
                </p>
                <p className="mt-3 font-mono text-[11px] tracking-[0.18em] text-[#636B78] uppercase">
                  A supporting benefit available on eligible products only
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
